// extracted by mini-css-extract-plugin
export var circleIcon = "survey-option-circle-module--circle-icon--+mbym";
export var circleInput = "survey-option-circle-module--circle-input--eDPGW";
export var circleOption = "survey-option-circle-module--circle-option--GZ0qd";
export var circleWrapper = "survey-option-circle-module--circle-wrapper--Oowa8";
export var imgCircle = "survey-option-circle-module--img-circle--PK-7t";
export var labelText = "survey-option-circle-module--label-text--UHHfm";